import React, { useState, useEffect } from 'react';
import { Input, Select, Switch, Tabs } from 'antd';
import { Option } from 'antd/lib/mentions';

import { Col, Row } from 'reactstrap';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css'; 
import validator from 'validator';

const UrlProps = (props) => {

    const { TextArea } = Input;
    const { TabPane } = Tabs;

    const [getApiUrl, setApiUrl] = useState("");
    const [getMethodType, setMethodType] = useState("");
    const [getHeaders, setHeaders] = useState("");
    const [getPayload, setPayload] = useState("");
    const [getTimeInterval, setTimeInterval] = useState("Nil");
    const [getQueryParam, setQueryParam] = useState("");
    const [getCallbackFlag, setCallbackFlag] = useState(false);
    const [getCallBackResponse, setCallBackResponse] = useState(`function (result) {\n   }`);
    const [errMessage, setErrMessage] = useState('')
    const editorStyle = {
        fontFamily: '"Fira code", "Fira Mono", monospace',
        fontSize: 13
    }

    useEffect(() => {

        let jsonData = props.propData !== null && 
        props.propData !== undefined && 
        props.propData.widgetData !== null && 
        props.propData.widgetData.length > 0 &&
        props.propData.widgetData[0];
        if(jsonData.hasOwnProperty("bind")){
            if(jsonData.bind.type === "URL"){
                let data = jsonData.bind;
                setApiUrl(data.apiUrl);
                setMethodType(data.methodType);  
                setHeaders(data.headers);  
                setPayload(data.payload);     
                setTimeInterval(data.timeInterval);
                setQueryParam(data.queryParam);
                setCallbackFlag(data.callbackFlag);
                setCallBackResponse(data.callbackObj);
            }else{
                defaultForms();
            }
        }else{
            defaultForms();
        }
      
      }, [props]);

    const defaultForms = () => {
        setApiUrl("");
        setMethodType("GET");
        setHeaders("");
        setPayload("");
        setTimeInterval("Nil");
        setQueryParam("");
        setCallbackFlag(false);
        setCallBackResponse(`function (result) {\n   }`);
}

const validate = (value) => {
    if(!validator.isURL(value)) {
        setErrMessage('URL invalid')
    } else {
        setErrMessage('')
    }
}
    const onChangePath = (e) => {
        setApiUrl(e.target.value)
        validate(e.target.value)
        let combineData = {
            type : "URL",
            apiUrl : e.target.value,
            methodType : getMethodType,
            headers : getHeaders,
            payload : getPayload,
            timeInterval : getTimeInterval,
            queryParam : getQueryParam,
            callbackObj : getCallBackResponse,
            callbackFlag :  getCallbackFlag
        }
        combineDataSource(combineData)
    };

    const onChangeMethodType = (value) => {
        setMethodType(value)
        let combineData = {
            type : "URL",
            apiUrl : getApiUrl,
            methodType : value,
            headers : getHeaders,
            payload : getPayload,
            timeInterval : getTimeInterval,
            queryParam : getQueryParam,
            callbackObj : getCallBackResponse,
            callbackFlag :  getCallbackFlag
        }
        combineDataSource(combineData)
    };

    const onChangeInterval = (value) => {
        setTimeInterval(value)
        let combineData = {
            type : "URL",
            apiUrl : getApiUrl,
            methodType : getMethodType,
            headers : getHeaders,
            payload : getPayload,
            timeInterval : value,
            queryParam : getQueryParam,
            callbackObj : getCallBackResponse,
            callbackFlag :  getCallbackFlag
        }
        combineDataSource(combineData)
    };

    const onChangeHeaders = (event) => {
        setHeaders(event)
        let combineData = {
            type : "URL",
            apiUrl : getApiUrl,
            methodType : getMethodType,
            headers : event,
            payload : getPayload,
            timeInterval : getTimeInterval,
            queryParam : getQueryParam,
            callbackObj : getCallBackResponse,
            callbackFlag :  getCallbackFlag
        }
        combineDataSource(combineData)
    };

    const onChangePayload = (event) => {
        setPayload(event)
        let combineData = {
            type : "URL",
            apiUrl : getApiUrl,
            methodType : getMethodType,
            headers : getHeaders,
            payload : event,
            timeInterval : getTimeInterval,
            queryParam : getQueryParam,
            callbackObj : getCallBackResponse,
            callbackFlag :  getCallbackFlag
        }
        combineDataSource(combineData)
    };

    const onChangeQueryParam = (event) => {
        setQueryParam(event.target.value)
        let combineData = {
            type : "URL",
            apiUrl : getApiUrl,
            methodType : getMethodType,
            headers : getHeaders,
            payload : event.target.value,
            timeInterval : getTimeInterval,
            queryParam : event.target.value,
            callbackObj : getCallBackResponse,
            callbackFlag :  getCallbackFlag
        }
        combineDataSource(combineData)
    };

    const onChangeCallBackResponse = (event) => {
        setCallBackResponse(event)
        let combineData = {
            type : "URL",
            apiUrl : getApiUrl,
            methodType : getMethodType,
            headers : getHeaders,
            payload : getPayload,
            timeInterval : getTimeInterval,
            queryParam : getQueryParam,
            callbackObj : event,
            callbackFlag :  getCallbackFlag

        }
        combineDataSource(combineData)
    };

    const onChangeIscallBack = (checked) => {
        if(!checked){
            setCallBackResponse(`function (result) {\n   }`);
        }
        setCallbackFlag(checked);
      };

    const combineDataSource = (data) => {
        props._getPropsForIndex(props.widgetIndex, data)
    }

    return <div >
        <Row className='mb-3'>
            <Col className='pl-1 m-0'>
                <label
                    className="form-control-label font12"
                >
                    Api Url
                </label> <br />
                <Input placeholder=' Api Url ' id='apiUrl' onChange={onChangePath} value={getApiUrl} name="apiUrl" />
                {props.errorFlag && <small className='df-text-danger'>Please Enter  Api Url </small>}
                <span className='pt-2 d-block' style={{ color: 'red'}}>{errMessage}</span>
            </Col>
        </Row>

        <Row className='mb-3'>
            <Col className='pl-1 m-0'>
                <label
                    className="form-control-label font12"
                >
                    Method Type
                </label>
                <Select defaultValue={getMethodType} id='methodType' onChange={onChangeMethodType} className="select-theme-width mt-2" name="methodType" 
                value={getMethodType}>
                    <Select.Option value="GET">GET</Select.Option>
                    <Select.Option value="POST">POST</Select.Option>
                </Select>
            </Col>

            <Col className='pl-1 m-0'>
                <label
                    className="form-control-label font12"
                >
                    Interval(In Seconds)
                </label>
                <Select defaultValue={getTimeInterval} id='timeInterval' onChange={onChangeInterval} className="select-theme-width mt-2" name="timeInterval" 
                value={getTimeInterval}>
                    <Select.Option value="Nil">Nil</Select.Option>
                    <Select.Option value="5">5</Select.Option>
                    <Select.Option value="10">10</Select.Option>
                    <Select.Option value="15">15</Select.Option>
                    <Select.Option value="20">20</Select.Option>
                    <Select.Option value="25">25</Select.Option>
                    <Select.Option value="30">30</Select.Option>
                </Select>
            </Col>
            <Col className='text-center m-0'>
                <label
                    className="form-control-label font12"
                >
                    Call Back
                </label>
                <br />
                <Switch checked ={getCallbackFlag} onChange={onChangeIscallBack}  className="mt-2"/>
            </Col>
        </Row>

        <Tabs defaultActiveKey="1" className='col pl-2 df-editor'>
            {getCallbackFlag && <TabPane tab="Callback Return" className='callback-return' key="1">
                <Editor
                    name="callbackObj" id="callbackObj"
                    value={getCallBackResponse}
                    onValueChange={code => onChangeCallBackResponse(code)}
                    highlight={code => highlight(code, languages.js)}
                    padding={5}
                    textareaId="codeArea"
                    className="callback-text-box"
                    style={editorStyle}
                />
            </TabPane>}

            <TabPane tab="Headers" key="2">
                <Editor
                    name="headers" id="headers"
                    value={getHeaders}
                    onValueChange={code => onChangeHeaders(code)}
                    highlight={code => highlight(code, languages.js)}
                    padding={5}
                    placeholder="Enter Headers"
                    textareaId="codeArea"
                    className="callback-text-box"
                    style={editorStyle}
                />
            </TabPane>

            {getMethodType === "POST" && <TabPane tab="Payload" key="3">
                <Editor
                    name="payload" id="payload"
                    value={getPayload}
                    onValueChange={code => onChangePayload(code)}
                    highlight={code => highlight(code, languages.js)}
                    padding={5}
                    placeholder="Enter Payload"
                    textareaId="codeArea"
                    className="callback-text-box"
                    style={editorStyle}
                />
            </TabPane>}

            {getMethodType === "GET" &&  <TabPane tab="Query Param" className='query-param' key="4">
            <TextArea rows={3} placeholder="Query Param"
                    name="queryParam" id="queryParam" onChange={onChangeQueryParam} value={getQueryParam} />

            </TabPane>}
        </Tabs>
    </div>
}
export default UrlProps;
